import { Fragment } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { __MUNICIPALITY_API_URL__ } from 'shell/constants/environment';
import { MunicipalityDetailForm } from 'system/geographic/components/municipality/form/detail-form';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonMunicipalityCrumbs } from '../constants';
import { HttpResponse } from 'shell/models/http-response';
import { Municipality } from 'shell/models/municipality';
import { noop } from 'shell/utils/noop';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import FormMunicipalityEnded from 'system/geographic/components/municipality/ended';
import { transformResponseMunicipalityEnded } from 'system/geographic/utils/transformer-municipality-ended';

const MunicipalityDetailEndedPage = (): React.ReactElement => {
  const params = useParams();

  const [municipalityData] = useHttpFetch<HttpResponse<Municipality>, MunicipalityDetailForm>(
    `${__MUNICIPALITY_API_URL__}/geo/comune/${params.id}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
      },
      transformer: transformResponseMunicipalityEnded,
    }
  );

  const municipality = municipalityData.data as MunicipalityDetailForm;

  const navigate = useNavigate();

  return (
    <Fragment>
      <Breadcrumbs items={[...CommonMunicipalityCrumbs, { name: 'Dettaglio Comune Soppresso' }]} />
      {municipalityData.isLoading || municipalityData.hasErrors || !municipality ? undefined : (
        <FormMunicipalityEnded
          title="Dettaglio Comune Soppresso"
          onOk={noop}
          initialValues={municipality}
          disabled
          onCancel={() => {
            navigate('/sistema/geografiche/comune');
          }}
        />
      )}
    </Fragment>
  );
};

MunicipalityDetailEndedPage.displayName = 'Municipality Detail ended page component';

export default MunicipalityDetailEndedPage;
